'use client';

import { BlurInH2 } from '@/components/eldora-ui/blur-in-h2';
import { useState } from 'react';

const FunctionalCertifications = () => {
  const tabs = [
    'Real Estate Solution',
    'Digital Workplace Solution',
    'Utilities Solution',
  ];
  const [activeTab, setActiveTab] = useState('Real Estate Solution');
  type Tab = (typeof tabs)[number];
  const data: Record<Tab, string[]> = {
    'Real Estate Solution': [
      'Financial Management Suite',
      'Customer Relationship Management Suite',
      'Supply Chain Management Suite',
      'Tenancy (Contract & Billing) Management Suite',
      'Utilities (Contract & Billing) Management Suite',
      'Building Asset and Maintenance Management Suite',
    ],
    'Digital Workplace Solution': [
      'Space Management',
      'Real Estate Lease Management',
      'Utilities Management',
      'Shared Resources Management',
      'Supply Chain Management',
      'Building Asset & Maintenance Management',
      'Parking Management',
      'Internet Portals',
      'Mobile Apps',
      'Common Utilities - Decision Support Modules',
      'Common Utilities - Application Configuration Tools',
      'Application Programming Interfaces',
    ],
    'Utilities Solution': [
      'Financial Management',
      'Customer Relationship Management',
      'Utilities Management',
      'Auto Metering Infrastructure',
      'Supply Chain Management',
      'Asset & Maintenance Management',
      'Internet Portals',
      'Mobile Apps',
      'Common Utilities - Decision Support Modules',
      'Common Utilities - Application Configuration Tools',
      'Application Programming Interfaces',
    ],
  };

  return (
    <div className=" bg-gray-50">
      <div className=" grid grid-cols-1 lg:grid-cols-5 mb-10">
        <div className="col-span-1"></div>
        <div className="col-span-4">
          <BlurInH2 className="mt-10 whitespace-pre-line">
            Functional{' '}
            <span className="font-light text-[#BF984D]">
              {'\nCertifications'}
            </span>
          </BlurInH2>

          <div className="relative flex border-b mt-8 gap-x-8">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`py-2 px-4 text-lg relative ${
                  activeTab === tab
                    ? 'text-yellow-600 border-b-2 border-yellow-600'
                    : 'text-gray-600'
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
                {activeTab === tab && (
                  <span className="absolute bottom-[-12px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-[12px] border-l-transparent border-r-[12px] border-r-transparent border-t-[12px] border-t-yellow-600"></span>
                )}
              </button>
            ))}
          </div>

          <ul className="mt-8 space-y-4">
            {data[activeTab]?.map((item, index) => (
              <li key={index} className="flex items-center gap-4">
                <div className="w-4 h-4 border-2 border-yellow-600 rounded-full"></div>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FunctionalCertifications;
